'use client';

import { useTranslation } from '@crehana/i18n';
import { LANGUAGES } from '@crehana/ts-types';
import cn from 'clsx';
import { Loader } from "../../Loader";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var PageLoader = function PageLoader(_ref) {
  var _ref2;
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size,
    languageCode = _ref.languageCode,
    className = _ref.className;
  var _useTranslation = useTranslation(),
    translationLanguageCode = _useTranslation.languageCode;
  var languageToUse = (_ref2 = languageCode !== null && languageCode !== void 0 ? languageCode : translationLanguageCode) !== null && _ref2 !== void 0 ? _ref2 : LANGUAGES.ES;
  var label = languageToUse === LANGUAGES.ES ? 'Cargando...' : 'Loading...';
  return /*#__PURE__*/_jsxs("div", {
    className: cn('tw-w-full tw-mx-auto tw-h-screen tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-00', className),
    children: [/*#__PURE__*/_jsx(Loader, {
      size: size
    }), /*#__PURE__*/_jsx("span", {
      className: "tw-block tw-font-subtitle4 tw-mt-2 tw-text-neutral-light-700 dark:tw-text-neutral-dark-500",
      children: label
    })]
  });
};